var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex my-4"},[_c('div',{staticClass:"text-primary font-semibold"},[_vm._v(_vm._s(_vm.$attrs.label))]),_c('div',{staticClass:"flex flex-1 flex-col justify-center"},[_c('q-separator',{attrs:{"inset":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }